import Vue from 'vue'
import Router from 'vue-router'

import store from './store'
import {getToken} from '@/assets/js/token.js'

Vue.use(Router)
import {Message} from "element-ui";
//系统入口
const layout = () => import('@/common/layout/index.vue');

//企业-主页
const home = () => import('@/views/center/list/index.vue');

// 企业-登录
const Login = () => import('@/views/login')


//企业-融资管理-申请管理
const applyManage = () => import('@/views/center/financingManage/applyManage/list/index.vue');
//企业-融资管理-申请管理-融资详情
const applyManageInfo = () => import('@/views/center/financingManage/applyManage/info/index.vue');

//企业-融资管理-发布融资需求
const financingNeeds = () => import('@/views/center/financingManage/financingNeeds/list/index.vue');
//企业-融资管理-发布融资需求-编辑
const financingEdit = () => import('@/views/center/financingManage/financingNeeds/edit/index.vue');
//企业-融资管理-发布融资需求-下一步智能匹配
const intelligentMatching = () => import('@/views/center/financingManage/financingNeeds/intelligentMatching/index.vue');
//企业-融资管理-发布融资需求-下一步智能匹配-提交成功
const submitSuccess = () => import('@/views/center/financingManage/financingNeeds/submitSuccess/index.vue');

//企业-融资管理-我的收藏
const myCollection = () => import('@/views/center/financingManage/myCollection/list/index.vue');

//企业-企业信息-信息认证
const FirmAuthentication = () => import('@/views/center/enterpriseInfo/info');
//企业-企业信息-平台外融资记录
const financingRecords = () => import('@/views/center/enterpriseInfo/financingRecords/list/index.vue');

//企业-企业信息-合作伙伴
const cooperationPartner = () => import('@/views/center/enterpriseInfo/cooperationPartner/list/index.vue');

//企业-企业信息-账号管理
const accountManage = () => import('@/views/center/enterpriseInfo/accountManage/list/index.vue');
//企业-添加贴息申请
const addDiscount = () => import('@/views/center/applyDiscount/addDiscount.vue');
//企业-重新添加贴息申请
const reApply = () => import('@/views/center/applyDiscount/reApply.vue');
//企业-贴息申请-政策申报
const applyDiscount = () => import('@/views/center/applyDiscount/list.vue');
//企业-贴息申请-我的申请
const myApply = () => import('@/views/center/applyDiscount/myApply.vue');
//企业-贴息详情
const discountDetail = () => import('@/views/center/applyDiscount/detail.vue');
//鄂尔多斯-首页
const Index = () => import('@/views/home/index.vue');
//门户-我的账户
const myAccount = () => import('@/views/center/list/index.vue');

//门户-中心简介
const centerIntroduction = () => import('@/views/centerIntroduction/index.vue');
//门户-找资金(产品)
const ProductionList = () => import('@/views/production/list');
//门户-找资金-详情
const capitalInfo = () => import('@/views/capital/info/index.vue');
//门户-找资金-详情-填写需求
const needsApplication = () => import('@/views/capital/needsApplication/index.vue');

//门户-找项目
const project = () => import('@/views/project/index.vue');

//门户-担保产品-详情
const guaranteeInfo = () => import('@/views/financial/guaranteeInfo/index.vue');
//门户-其它产品-详情
const otherInfo = () => import('@/views/financial/otherInfo/index.vue');
// const otherInfo = () => import('@/views/financial/OtherInfo.vue');
//门户-政策动态
const dynamic = () => import('@/views/dynamic/list/index.vue');
//门户-政策动态-详情
const dynamicInfo = () => import('@/views/dynamic/info/index.vue');

//门户-绿融通
const discount = () => import('@/views/dynamic/list/index.vue');
//门户-绿融通详情
const discountInfo = () => import('@/views/dynamic/detail/index.vue');


//门户-绿融通
const green = () => import('@/views/green/index.vue');

const router = new Router({
    routes: [
        {
            path: '/',
            redirect: {
                name: 'index'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        //鄂尔多斯-首页
        {
            path: '/index',
            name: 'index',
            component:Index,
        },
        {
            path: '/',
            name: 'layout',
            component: layout,
            redirect: {
                name: 'index'
            },
            children: [
                {
                    path: 'centerIntroduction',
                    name: 'centerIntroduction',
                    component: centerIntroduction,
                    meta: {
                        id: '200',
                        title: '平台介绍',
                    },
                },
                {
                    path: 'productionList',
                    name: 'productionList',
                    component: ProductionList,
                    meta: {
                        id: '300',
                        title: '找资金',
                    }
                },
                {
                    path: 'capitalInfo',
                    name: 'capitalInfo',
                    component: capitalInfo,
                    meta: {
                        id: '300',
                        title: '找资金-详情',
                    },
                },
                {
                    path: 'needsApplication',
                    name: 'needsApplication',
                    component: needsApplication,
                    meta: {
                        id: '300',
                        title: '找资金-详情-填写需求',
                    },
                },
                {
                    path: 'project',
                    name: 'project',
                    component: project,
                    meta: {
                        id: '400',
                        title: '找项目',
                    },
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: dynamic,
                    meta: {
                        id: '500',
                        title: '政策新闻',
                    },
                },
                {
                    path: 'dynamicInfo',
                    name: 'dynamicInfo',
                    component: dynamicInfo,
                    meta: {
                        id: '500',
                        title: '政策动态详情',
                    },
                },
                {
                    path: 'discount',
                    name: 'discount',
                    component: discount,
                    meta: {
                        id: '600',
                        title: '绿融通',
                    },
                },
                {
                    path: 'green',
                    name: 'green',
                    component: green,
                    meta: {
                        id: '600',
                        title: '绿融通',
                    },
                },
                {
                    path: 'discountInfo',
                    name: 'discountInfo',
                    component: discountInfo,
                    meta: {
                        id: '600',
                        title: '绿融通详情',
                    },
                },
                {
                    path: 'myAccount',
                    name: 'myAccount',
                    component: myAccount,
                    meta: {
                        id: '100',
                        sid: '100',
                        title: '企业-我的账户',
                    },
                },
                {
                    path: 'guaranteeInfo',
                    name: 'guaranteeInfo',
                    component: guaranteeInfo,
                    meta: {
                        id: '700',
                        title: '担保产品详情',
                    },
                },
                {
                    path: 'otherInfo',
                    name: 'otherInfo',
                    component: otherInfo,
                    meta: {
                        id: '700',
                        title: '其他产品详情',
                    },
                },
                //企业
                {
                    path: 'home',
                    name: 'home',
                    component: home,
                    meta: {
                        id: '100',
                        sid: '1000',
                        title: '企业-主页',
                    },
                },
                {
                    path: 'applyManage',
                    name: 'applyManage',
                    component: applyManage,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20001',
                        title: '企业-融资管理-申请管理',
                    },
                },
                {
                    path: 'applyManageInfo',
                    name: 'applyManageInfo',
                    component: applyManageInfo,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20001',
                        title: '企业-融资管理-申请管理-融资详情',
                    },
                },
                {
                    path: 'financingNeeds',
                    name: 'financingNeeds',
                    component: financingNeeds,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20002',
                        title: '企业-融资管理-发布融资需求',
                    },
                },
                {
                    path: 'financingEdit',
                    name: 'financingEdit',
                    component: financingEdit,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20002',
                        title: '企业-融资管理-发布融资需求-编辑',
                    },
                },
                {
                    path: 'intelligentMatching',
                    name: 'intelligentMatching',
                    component: intelligentMatching,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20002',
                        title: '企业-融资管理-发布融资需求-智能匹配',
                    },
                },
                {
                    path: 'submitSuccess',
                    name: 'submitSuccess',
                    component: submitSuccess,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20002',
                        title: '企业-融资管理-发布融资需求-智能匹配-提交成功',
                    },
                },
                {
                    path: 'myCollection',
                    name: 'myCollection',
                    component: myCollection,
                    meta: {
                        id: '100',
                        parents: '2000',
                        sid: '20003',
                        title: '企业-融资管理-我的收藏',
                    },
                },
                /*{applyDiscount
                    path: 'preBusiness',
                    name: 'preBusiness',
                    component: preBusiness,
                    meta: {
                        id: '100',
                        sid: '5000',
                        title: '企业-预授信业务',
                    },
                },*/
                {
                    path: 'info',
                    name: 'info',
                    component: FirmAuthentication,
                    meta: {
                        id: '100',
                        parents: '4000',
                        sid: '40001',
                        title: '企业-企业信息-信息认证',
                    },
                },
                {
                    path: 'financingRecords',
                    name: 'financingRecords',
                    component: financingRecords,
                    meta: {
                        id: '100',
                        parents: '4000',
                        sid: '40002',
                        title: '企业-企业信息-平台外融资记录',
                    },
                },
                {
                    path: 'cooperationPartner',
                    name: 'cooperationPartner',
                    component: cooperationPartner,
                    meta: {
                        id: '100',
                        parents: '4000',
                        sid: '40003',
                        title: '企业-企业信息-合作伙伴',
                    },
                },
                {
                    path: 'accountManage',
                    name: 'accountManage',
                    component: accountManage,
                    meta: {
                        id: '100',
                        parents: '4000',
                        sid: '40004',
                        title: '企业-企业信息-账号管理',
                    },
                },//
                {
                    path: 'addDiscount',
                    name: 'addDiscount',
                    component: addDiscount,
                    meta: {
                        id: '100',
                        sid: '3000',
                        title: '添加贴息申请',
                    },
                },
                {
                    path: 'reApply',
                    name: 'reApply',
                    component: reApply,
                    meta: {
                        id: '100',
                        sid: '3000',
                        title: '添加贴息申请',
                    },
                },
                {
                    path: 'applyDiscount',
                    name: 'applyDiscount',
                    component: applyDiscount,
                    meta: {
                        id: '100',
                        parents: '3000',
                        sid: '30001',
                        title: '政策申报',
                    },
                },
                {
                    path: 'myApply',
                    name: 'myApply',
                    component: myApply,
                    meta: {
                        id: '100',
                        parents: '3000',
                        sid: '30002',
                        title: '我的申请',
                    },
                },
                {
                    path: 'discountDetail',
                    name: 'discountDetail',
                    component: discountDetail,
                    meta: {
                        id: '100',
                        sid: '3000',
                        title: '贴息详情',
                    },
                },
            ]
        },
        {
            path: '*',
            redirect: {
                name: 'layout'
            }
        }
    ]
})
import { dataSource } from "@/api/api.js";

router.beforeEach((to, from, next) => {

    // 如果登录了，并且没有用户信息，获取用户信息
    if (getToken() && !store.state.userInfo.username) {
        store.dispatch('getCompanyInfo')
    }
    if (to.name === 'applyManage' || to.name === 'myCollection' || to.name === 'preBusiness' || to.name === 'financingRecords' || to.name === 'cooperationPartner' || to.name === 'addDiscount' || to.name === 'applyDiscount') {
        dataSource.postCompanyFinanceState().then(res => { //判断 是否有未完成的融资
            let data = res.data.data;
            if (!data.authStatus) {
                Message({
                    message: '未完成认证',
                    type: 'error',
                    duration: 5000
                });
                return false;
            }
            if (data.authStatus) {

                let data = {
                    parents: '',
                    parent: '',
                    id: '',
                }
                if (to.meta.parents) {
                    data.parents = to.meta.parents;
                }
                if (to.meta.parent) {
                    data.parent = to.meta.parent;
                }
                if (to.meta.id) {
                    data.id = to.meta.sid;
                }
                //一级导航
                sessionStorage.setItem('homeNav', to.meta.id);
                //首页导航
                sessionStorage.setItem('enterpriseNavId', JSON.stringify(data));
                //设置页面回到顶部
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                next();
            }

        }).catch(err => {
        })
    } else {
        if (to.name === 'financingNeeds') { //判断是否进入发布融资需求页面
            dataSource.postCompanyFinanceState().then(res => { //判断 是否有未完成的融资
                let data = res.data.data;
                // console.log(data)
                if (!data.authStatus) {
                    Message({
                        message: '未完成认证',
                        type: 'error',
                        duration: 5000
                    });
                }
                if (!data.financeStatus) {
                    Message({
                        message: '有未完成的融资',
                        type: 'error',
                        duration: 5000
                    });
                }
                if (data.authStatus && data.financeStatus) {
                    //进入发布融资需求页面判断是编辑还是新增
                    let data1 = {
                        productId: '',
                        state: "新增",
                    }
                    sessionStorage.setItem('editProduct', JSON.stringify(data1));
                    let data = {
                        parents: '',
                        parent: '',
                        id: '',
                    }
                    if (to.meta.parents) {
                        data.parents = to.meta.parents;
                    }
                    if (to.meta.parent) {
                        data.parent = to.meta.parent;
                    }
                    if (to.meta.id) {
                        data.id = to.meta.sid;
                    }
                    //一级导航
                    sessionStorage.setItem('homeNav', to.meta.id);
                    //首页导航
                    sessionStorage.setItem('enterpriseNavId', JSON.stringify(data));
                    //设置页面回到顶部
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    next();
                }

            }).catch(err => {
            })
        } else {
            let data = {
                parents: '',
                parent: '',
                id: '',
            }
            if (to.meta.parents) {
                data.parents = to.meta.parents;
            }
            if (to.meta.parent) {
                data.parent = to.meta.parent;
            }
            if (to.meta.id) {
                data.id = to.meta.sid;
            }
            //一级导航
            sessionStorage.setItem('homeNav', to.meta.id);
            //首页导航
            sessionStorage.setItem('enterpriseNavId', JSON.stringify(data));
            //设置页面回到顶部
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            next();
        }
    }
    if (from.name !== 'index' && to.name !== 'financingNeeds') { //找资金页面
        let data1 = {
            loadMoney: "",
            loadTime: "",
            loadType: "",
            state: "0",
        }
        sessionStorage.setItem("loadInfo", JSON.stringify(data1));

        let loadLimitNum = {
            itemLeftInterval: null,
            itemRightInterval: null,
        };
        let loadTermNum = {
            itemLeftInterval: null,
            itemRightInterval: null,
        };
        sessionStorage.setItem('loadTypeNum', "");
        sessionStorage.setItem("loadLimitNum", JSON.stringify(loadLimitNum));
        sessionStorage.setItem("loadTermNum", JSON.stringify(loadTermNum));
    }
    if(to.name === 'dynamic'){//政策新闻页
        sessionStorage.setItem("newsType","80010001");
        store.commit('updataNewsType', "80010001");
        let data = {
            parents: '',
            parent: '',
            id: '',
        }
        if (to.meta.parents) {
            data.parents = to.meta.parents;
        }
        if (to.meta.parent) {
            data.parent = to.meta.parent;
        }
        if (to.meta.id) {
            data.id = to.meta.sid;
        }
        //一级导航
        sessionStorage.setItem('homeNav', to.meta.id);
        //首页导航
        sessionStorage.setItem('enterpriseNavId', JSON.stringify(data));
        //设置页面回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        next();
    }
    if(to.name === 'discount'){//绿融通页
        sessionStorage.setItem("newsType","80010005");
        store.commit('updataNewsType', "80010005");
        let data = {
            parents: '',
            parent: '',
            id: '',
        }
        if (to.meta.parents) {
            data.parents = to.meta.parents;
        }
        if (to.meta.parent) {
            data.parent = to.meta.parent;
        }
        if (to.meta.id) {
            data.id = to.meta.sid;
        }
        //一级导航
        sessionStorage.setItem('homeNav', to.meta.id);
        //首页导航
        sessionStorage.setItem('enterpriseNavId', JSON.stringify(data));
        //设置页面回到顶部
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        next();
    }

})
export default router;
